// extracted by mini-css-extract-plugin
module.exports = {"value":"Item_value__3YdTY","value--secondary-selected":"Item_value--secondary-selected__2PVhR","value--selected":"Item_value--selected__3vAvT"};